import { render } from "./affairList.vue?vue&type=template&id=6003778e&scoped=true"
import script from "./affairList.vue?vue&type=script&lang=js"
export * from "./affairList.vue?vue&type=script&lang=js"

import "./affairList.vue?vue&type=style&index=0&id=6003778e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6003778e"]])

export default __exports__